import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Grid } from '@mui/material';

import CampaigncenterDashboard from '../CampaigncenterDashboard';

import { openDrawer } from './../../../store/slice/MenuSlice';
import CampaigncenterPageImpl from './CampaigncenterPageImpl';

export default function CampaigncenterPage() {
    const dispatch = useDispatch();
    const { campaigncenterList} = useSelector((state)=>state.manufslice)
    useEffect(() => {
        dispatch(openDrawer({'drawerOpen':true}));
    },[]);

    return (
        < CampaigncenterPageImpl />
    )

}